/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Thien H: 2022 Nov 15
// size chart modal
var forEach = function (array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]); // passes back stuff we need
  }
};

const modal_triggers = document.querySelectorAll('.modal-trigger__link');
const close_btn = document.querySelectorAll('.popup__close-btn');
const body = document.querySelector('html');
const backdrop = document.querySelectorAll('.modal-backdrop');
let isModalOpen = false;

function showModalZSG() {
  let target_modal_id = this.dataset.target;
  let the_modal = document.querySelector(target_modal_id);
  the_modal.classList.add("show");
  body.style.overflow = 'hidden';
  isModalOpen = true;
}

function hideModalZSG() {
  let modal = document.querySelectorAll('.zsg-popup-container');
  forEach(modal, function(i, e) {
    e.classList.remove('show');
  });
  body.style.overflow = 'auto';
  isModalOpen = false;
}

if(modal_triggers) {
  forEach(modal_triggers, function(index, ele) {
    ele.addEventListener("click", showModalZSG);
  });
}

if(close_btn) {
  forEach(close_btn, function(index, ele) {
    ele.addEventListener('click', hideModalZSG);
  });
}
///close modal on overlay click
window.addEventListener("click", function(event) {
  forEach(backdrop, function(i, e) {
    if(event.target === e) hideModalZSG();
  });
});
// Close modal on Esc key
document.onkeydown = function(evt) {
  evt = evt || window.event;
  if (evt.keyCode == 27) {
    hideModalZSG();
  }
};

// Line Item Note
const note_trigger = document.getElementById('order_note_trigger');
const field_wrapper = document.getElementById('note_field_wrapper');
const closeFieldNote = (elem, open_now) => {
  if(open_now == 'true') {
    open_now = 'false';
    elem.style.maxHeight = '0px';
    elem.style.opacity = '0';
    elem.setAttribute('aria-expanded', open_now);
  }
  return open_now;
}
const openFieldNote = (elem, open_now) => {
  if(open_now == 'false') {
    open_now = 'true';
    elem.style.maxHeight = elem.scrollHeight + 'px';
    elem.style.opacity = '1';
    elem.setAttribute('aria-expanded', open_now);
  }
  return open_now;
}
if(note_trigger && field_wrapper) {
  note_trigger.addEventListener('click', function(event) {
    event.preventDefault();
    let isOpen = this.getAttribute('aria-expanded');
    if(isOpen == 'false') { 
      openFieldNote(field_wrapper, isOpen);
      isOpen = 'true';
    }
    else {
      closeFieldNote(field_wrapper, isOpen);
      isOpen = 'false';
    }
    this.setAttribute('aria-expanded', isOpen);
    
  });
}